import '../styles/Songs.css';
import Logo from './Logo';
import collection from '../data/songs.js';

export default function Songs() {
  return (
    <div className="songs">
      <Logo />
      <h2>Song List</h2>
      <div className="songs-content">
        {collection.map((details, index) => (
          <div key={index} className="song-item">
            <h4>{details.artist}</h4>
            <ul className="song-titles">
              {details.titles.map((title, i) => (
                <li key={i}>{title}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}